module.exports = __webpack_public_path__ + "img/yz1.e0c72167.png";